import React from "react";
import { useTranslation } from "react-i18next";
import executionCheck from "../../img/experience/execution-check.svg";

const FEATURES = ["exp.execution.f1", "exp.execution.f2", "exp.execution.f3", "exp.execution.f4"];

function FeaturePill({ labelKey }) {
  const { t } = useTranslation();
  return (
    <div className="bg-[#1e1e1e] rounded-[20px] flex items-center gap-[20px] xl:gap-[40px] px-[20px] xl:px-[40px] py-[18px] xl:py-[19px]">
      <div className="border border-[#383838] rounded-[15px] xl:rounded-[28px] size-[30px] xl:size-[56px] flex items-center justify-center shrink-0 overflow-hidden">
        <div className="relative size-[16px] xl:size-[30px]">
          <div
            className="absolute"
            style={{ inset: "17.53% 9.2% 19.11% 9.19%" }}
          >
            <img src={executionCheck} alt="" aria-hidden className="absolute inset-0 w-full h-full max-w-none" />
          </div>
        </div>
      </div>
      <span className="font-['Montserrat'] font-semibold text-[14px] xl:text-[20px] text-white leading-normal">
        {t(labelKey)}
      </span>
    </div>
  );
}

function Execution() {
  const { t } = useTranslation();

  return (
    <section className="mt bg-[#0a0a0a] py-[60px] xl:py-[120px]">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[80px]">
        {/* Heading row */}
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-[20px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-white tracking-[-0.92px] uppercase leading-none xl:max-w-[497px]">
            {t("exp.execution.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[588px]">
            {t("exp.execution.desc")}
          </p>
        </div>

        {/* Feature pills: 2 cols on desktop */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-[12px] xl:gap-[14px]">
          {FEATURES.map((key) => (
            <FeaturePill key={key} labelKey={key} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Execution;
